export const members_introduction = "Pour adhérer à FASOCRED, il faut se prémunir de la photocopie d'une Carte Nationale d'Identité Burkinabe ou d'un passeport, de deux photos d'identité et de frais d'ouverture. Les membres de plein droit, les membres actifs-usager et les membres parrains constituent le capital social de FASOCRED. Tout membre doit être âgé de 18 ans au moins et 71 ans au plus."

export const members_section ={
    title: 'Membres',
    id: 'membres'
}

export const members_types= [{
    member_name: 'Membres (adhérents) de plein droit',
    conditions: ['droits d’adhésion 3000 FCFA.', 'capital social 2000 FCFA.',
                    'épargne solidaire, équivalant à 500 000 FCFA.', 'Solde minimum 100 000 FCFA.'
                ]
},
{
    member_name: 'Membres (adhérents) actif-usagers',
    conditions: ['droits d’adhésion 3000 FCFA.', 'Capital social 2000 FCFA.',
                    'Solde minimum P.PH (Personne physique) 2500 FCFA.', 'Solde minimum P.MR (Personne morale) 10000 FCFA.'
                ]
},
{
    member_name: 'Membres (adhérents) parrains',
    conditions: [
        'droits d’adhésion 3000 FCFA.', 'capital social 2000 FCFA.', 'Solde minimum P.PH (Personne physique)10000 FCFA.',
        'Solde minimum P.MR (Personne morale)20000 FCFA.'
    ]
}];
export const members_conditions_extra = 'NB : Les parts sociales sont personnelles, individuelles, non négociables et non saisissables par les tiers. Elles ne sont remboursables aux membres démissionnaires ou exclus, ou aux ayants-droits des membres décédés, qu’après apurement du solde des créances et dettes à l’égard de FASOCRED. Les droits d’adhésion constituent les frais d’ouverture de compte et ne sont remboursables. Les frais de gestion de compte s’élèvent à 500 FCFA par mois.'

export const members_rights_section ={
    title: 'Droits des membres',
    id: 'members_rights'
}

export const members_rights = [{
    member_name : 'membre de plein droit',
    rights: ['Devenir membre et pouvoir démissionner librement.', 
'Faire librement des opérations de dépôt et de retrait sur son compte.',
'Avoir un droit de regard sur la coopérative (membres de plein droit) et contribuer à son bon fonctionnement en formulant des critiques et des suggestions.',
'Participer aux Assemblées Générales, avec droit de vote.',
'Etre candidat aux différents postes de membres des organes de FASOCRED dans les conditions prévues au Règlement Intérieur.',
'Aux informations produites par FASOCRED, suivant les conditions du Règlement Intérieur',
'Aux services et produits offerts par FASOCRED']
},
{
    member_name : 'membre Actif-usager',
    rights: ['Devenir membre actif et pouvoir démissionner librement.',
'Faire librement des opérations de dépôt et de retrait sur son compte.',
'Participer aux Assemblées Générales, sans droit de vote.',
'Etre candidat aux différents postes de membres des organes, sauf au Conseil d’Administration ou Comité de Gestion de FASOCRED dans les conditions prévues au Règlement Intérieur.',
'Aux informations produites par FASOCRED, suivant les conditions du Règlement Intérieur.',
'Aux services et produits offerts par FASOCRED.']
},
{
    member_name : 'membre parrain',
    rights: ['Devenir membre parrain et pouvoir démissionner librement.',
'Faire librement des opérations de dépôt et de retrait sur son compte.',
'Participer aux Assemblées Générales, sans droit de vote.',
'Etre candidat aux différents postes de membres des organes de FASOCRED, sauf au Conseil d’Administration ou Comité de Gestion dans les conditions prévues au Règlement Intérieur.',
'Aux informations produites par FASOCRED, suivant les conditions du Règlement Intérieur.',
'Aux services et produits offerts par FASOCRED.']
}]


export const members_obligations_section ={
    title: 'Devoirs des membres',
    id: 'members_obligations'
}

export const members_obligations = ['Respecter les règles de FASOCRED à travers ses Statuts et Règlement Intérieur.',
'Respecter les décisions de l’Assemblée Générale, du Conseil d’Administration de FASOCRED.',
'Honorer ses engagements à FASOCRED.']

export const members_suspensions_section ={
    title: 'Suspension ou exclusion de membre',
    id: 'members_suspension'
}

export const members_suspensions_introduction = 'Le Conseil d’Administration peut suspendre un membre en attendant la tenue de l’AGO suivante. Elle doit motiver sa décision et soumettre à l’AGO. L’exclusion n’est effective qu’à la suite de la décision de l’Assemblée Générale.'
export const members_suspensions = ['s’il ne respecte pas les principes et règles disciplinaires de FASOCRED.',
'si le membre refuse d’honorer ses engagements contractuels.',
'Si le membre pause des actes susceptibles de ternir l’image de FASOCRED.',
'Si le membre ne jouit plus de ses facultés mentales.']
export const members_suspensions_conclusion = 'En cas de suspension d\'un membre, le Conseil d’Administration mentionne dans son procès-verbal de la séance statutaire ou extraordinaire au cours de laquelle le membre est suspendu les faits qui ont motivé cette décision. Le CA ou le DG signifie au membre suspendu par lettre sa décision de suspension.'